<template>
    <div class="activate-account-page">
    </div>
</template>

<script>
    export default {
        name: 'ActivateAccountPage',
        metaInfo: {
            title: 'Khonsu - ActivateAccountPage'
        },
        async mounted() {
            let activateUser = await this.$store.dispatch('UserManagement/activateUser',{
                'email': this.$route.params.email,
                'activationCode': this.$route.params.activationCode
            });

            if (activateUser) {
                this.$router.push('/login');
            }

            if (!activateUser) {
                this.$router.push('/login');
            }
        }
    }
</script>